/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import {
    ComposedChart, Bar, Line, Label, XAxis, YAxis, CartesianGrid,
    Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import PropTypes from 'prop-types';
import { DefaultTooltipContent } from 'recharts/lib/component/DefaultTooltipContent';
import { setCurrencyFormat, colorArray } from '../../../utils/helpers';


export const CustomTooltip = (props) => {
    // eslint-disable-next-line react/prop-types
    const { active, payload, keyRef, dailyMonthlyOptions } = props;
    // we don't need to check payload[0] as there's a better prop for this purpose
    if (!active) {
        // I think returning null works based on this: http://recharts.org/en-US/examples/CustomContentOfTooltip
        return null
    }
    // mutating props directly is against react's conventions
    // so we create a new payload with the name and value fields set to what we want
    // eslint-disable-next-line react/prop-types
    const data = payload[0]?.payload;

    let newPayload = { ...payload };

    if (data) {
        newPayload = Object.keys(data).map((key) => {

            if (key === keyRef?.aov) {
                return {
                    name: keyRef?.aov,
                    value: setCurrencyFormat(Number(data?.[keyRef?.aov]).toFixed(2), true),
                }
            }

            if (key === keyRef?.aupt) {
                return {
                    name: keyRef?.aupt,
                    value: setCurrencyFormat(Number(data?.[keyRef?.aupt]).toFixed(2), false),
                }
            }

            return {
                name: dailyMonthlyOptions?.value ? 'Month' : 'Day',
                value: data?.day,
            }

        })
    }



    // we render the default, but with our overridden payload
    return <DefaultTooltipContent {...props} payload={newPayload} />;
};


export function MultiAxisBar({ dataToPlot, dir, height, keyRef, dailyMonthlyOptions }) {
    return (
        <ResponsiveContainer height={height}>
            <ComposedChart
                data={dataToPlot}
                margin={{
                    top: 0, right: 0, left: 25, bottom: 0,
                }}
            >
                <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2} />
                <XAxis dataKey="day" reversed={dir === 'rtl'} />

                <YAxis yAxisId="left" orientation={dir === 'rtl' ? 'right' : 'left'}
                    tickFormatter={item => setCurrencyFormat(item, false)}
                    width={90} type="number"
                    allowDataOverflow >
                    <Label angle={-90} value={keyRef?.aupt?.toString()}
                        position='insideLeft' style={{ textAnchor: 'middle' }} />
                </YAxis>
                <YAxis yAxisId="right" orientation={dir === 'rtl' ? 'left' : 'right'}
                    tickFormatter={item => setCurrencyFormat(item, true)}
                    width={90} type="number"
                    allowDataOverflow >
                    <Label angle={-90} value={keyRef?.aov?.toString()}
                        position='insideRight' style={{ textAnchor: 'middle' }} />
                </YAxis>
                <Tooltip content={<CustomTooltip keyRef={keyRef} dailyMonthlyOptions={dailyMonthlyOptions}
                />}
                />  <Legend />
                <Bar type="monotone" yAxisId="right" dataKey={keyRef?.aov?.toString()} fill="#82ca9d" />
                <Line dot={false} yAxisId="left" dataKey={keyRef?.aupt?.toString()} fill="#8884d8" />
            </ComposedChart>
        </ResponsiveContainer>
    );
}

MultiAxisBar.propTypes = {
    dir: PropTypes.string.isRequired,
    dataToPlot: PropTypes.array.isRequired,
    height: PropTypes.number.isRequired,
    keyRef: PropTypes.object.isRequired,
    dailyMonthlyOptions: PropTypes.object.isRequired
};

MultiAxisBar.defaultProps = {

}


export default MultiAxisBar;